import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook } from "lucide-react";
import MountainRidge from "./MountainRidge";
import { openCookieSettings } from "./CookieConsent";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      id="footer-section"
      data-testid="footer-section"
      className="relative bg-[#1F2937] text-[#F7F9FB] pt-20 lg:pt-24 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 pb-14">
          <div className="lg:col-span-5">
            <Link to="/" className="inline-flex items-center gap-3 group">
              <img
                src="/logo.png"
                alt="Alex Buchner Logo"
                className="h-12 w-12 object-contain bg-white rounded-xl p-1.5"
              />
              <span className="font-display font-bold text-xl tracking-tight">
                Alex Buchner <span className="text-[#6FB04F]">Health</span>
              </span>
            </Link>
            <p className="mt-5 text-[#F7F9FB]/65 leading-relaxed max-w-sm">
              Personal Training & Mikronährstoffberatung aus einer Hand. Im
              Chiemgau – vor Ort und online.
            </p>
            <div className="mt-7 flex items-center gap-3">
              <a
                href="https://www.instagram.com/alex_buchner_?igsh=MWRhdzcyODZhMm15YQ=="
                target="_blank"
                rel="noreferrer"
                data-testid="footer-social-instagram"
                aria-label="Instagram"
                className="h-10 w-10 rounded-full border border-[#F7F9FB]/15 flex items-center justify-center hover:border-[#2E89C4] hover:text-[#2E89C4] transition"
              >
                <Instagram size={16} />
              </a>
              <a
                href="https://www.facebook.com/share/1DrjG67Qt1/"
                target="_blank"
                rel="noreferrer"
                data-testid="footer-social-facebook"
                aria-label="Facebook"
                className="h-10 w-10 rounded-full border border-[#F7F9FB]/15 flex items-center justify-center hover:border-[#2E89C4] hover:text-[#2E89C4] transition"
              >
                <Facebook size={16} />
              </a>
            </div>
          </div>

          <div className="lg:col-span-3">
            <p className="text-xs font-semibold tracking-[0.18em] uppercase text-[#F7F9FB]/45 mb-4">
              Bereiche
            </p>
            <ul className="space-y-2.5 text-sm">
              <li>
                <a
                  href="#pain-section"
                  className="text-[#F7F9FB]/75 hover:text-[#2E89C4] transition"
                >
                  Erkenntnis
                </a>
              </li>
              <li>
                <a
                  href="#outcome-section"
                  className="text-[#F7F9FB]/75 hover:text-[#2E89C4] transition"
                >
                  Ergebnis
                </a>
              </li>
              <li>
                <a
                  href="#product-intro-section"
                  className="text-[#F7F9FB]/75 hover:text-[#2E89C4] transition"
                >
                  So arbeite ich
                </a>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="text-xs font-semibold tracking-[0.18em] uppercase text-[#F7F9FB]/45 mb-4">
              Rechtliches
            </p>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link
                  to="/impressum"
                  data-testid="footer-link-impressum"
                  className="text-[#F7F9FB]/75 hover:text-[#2E89C4] transition"
                >
                  Impressum
                </Link>
              </li>
              <li>
                <Link
                  to="/datenschutz"
                  data-testid="footer-link-datenschutz"
                  className="text-[#F7F9FB]/75 hover:text-[#2E89C4] transition"
                >
                  Datenschutz
                </Link>
              </li>
              <li>
                <Link
                  to="/agb"
                  data-testid="footer-link-agb"
                  className="text-[#F7F9FB]/75 hover:text-[#2E89C4] transition"
                >
                  AGB
                </Link>
              </li>
              <li>
                <button
                  type="button"
                  data-testid="footer-link-cookies"
                  onClick={openCookieSettings}
                  className="text-[#F7F9FB]/75 hover:text-[#2E89C4] transition text-left"
                >
                  Cookie-Einstellungen
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#F7F9FB]/10 pt-6 pb-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-[#F7F9FB]/45">
            © {year} Alex Buchner Health. Alle Rechte vorbehalten.
          </p>
          <p className="text-xs text-[#F7F9FB]/45">
            Gestaltet mit Sorgfalt im Chiemgau.
          </p>
        </div>
      </div>

      {/* Anchor ridgeline at the very bottom */}
      <div className="mt-2">
        <MountainRidge fill="#0F1825" accent="#2E89C4" bg="#1F2937" />
      </div>
    </footer>
  );
}
